export default {
  signal: 'Signál',
  axis: 'Os',
  color: 'Farba',
  thickness: 'Hrúbka',
  stepped: 'Schodkový',
  selectAxisPlaceholder: 'Vybrať alebo vytvoriť os',
  auto: 'Automatický',
  addSignal: 'Pridať signály',
  selectSignals: 'Vybrať signály',
};
